import React from 'react';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TRecord} from '@packages/systems/wfdl-ast';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {extraAtomFields} from '@packages/shared/constants/Atoms';

import {QUANTITY_ENABLED} from '@packages/systems/commerce/constants';
import {quantityInputStyle, mobileCheckoutInputStyle} from './styles';
import {defaultIntegratedTypes} from '@packages/utilities/integrated-types';

const CommerceQuantityInput = Atom.createRender(
  ({attributes, classes, context, generateAttributes}) => {
    if (!context.get(QUANTITY_ENABLED)) {
      return null;
    }
    const props = {...generateAttributes(attributes, classes)} as const;
    // @ts-expect-error - TS2542 - Index signature in type '{ readonly [x: string]: string; readonly style: StyleAttributeObject; readonly ref: any; }' only permits reading.
    props.defaultValue = props.value;

    // @ts-expect-error - TS2542 - Index signature in type '{ readonly [x: string]: string; readonly style: StyleAttributeObject; readonly ref: any; }' only permits reading.
    // eslint-disable-next-line webflow/no-delete
    delete props.value;

    return (
      // TODO (platform): hardcoded type should be "number"

      <input type="text" pattern="^[0-9]+$" inputMode="numeric" {...props} />
    );
  }
);

// eslint-disable-next-line unused-imports/no-unused-vars, unused-imports/no-unused-vars
const {attr, ...rest} = defaultIntegratedTypes;

const config = Atom.create({
  displayName: 'Quantity',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  showEmpty: false,
  dataType: TRecord(rest, extraAtomFields),
  constraints: {
    ancestors: [
      {
        is: 'CommerceAddToCartForm',
        rule: 'ExactlyOne',
      },
    ],
  },
  style: {
    base: {
      main: quantityInputStyle,
      tiny: mobileCheckoutInputStyle,
    },
  },
  render: CommerceQuantityInput,
});

export default config;
